<template>
  <v-data-table
    :class="`table data-table data-table__green-border ${className}`"
    disable-sort
    hide-default-footer
    :headers="headers"
    :items="items"
  >
    <template v-slot:item.action="{ item }">
      <div class="table_actions">
        <v-icon dark color="error" @click.stop="deleteItem(item.id)"> mdi-delete </v-icon>
      </div>
    </template>

    <template v-slot:body="{ items }">
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <template v-for="(value, field) in item">
            <td class="text-start" :width="headersMap[field].width" v-if="headersMap[field]" :key="field">
              {{ value }}
            </td>
          </template>
          <td class="text-right">
            <div class="table_actions">
              <v-icon dark color="error" @click.stop="deleteItem(item.id)"> mdi-delete </v-icon>
            </div>
          </td>
        </tr>
      </tbody>
    </template>

    <template v-slot:no-data>
      <span class="data-table__no-items">
        {{ $t("general.table.noItems") }}
      </span>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: "DataTable",
  props: ["headers", "items", "className"],
  methods: {
    deleteItem(id) {
      this.$emit("delete", id);
    },
  },
  computed: {
    headersMap() {
      return this.headers.reduce((result, item) => {
        result[item.value] = item;
        return result;
      }, {});
    },
  },
};
</script>
